import React from 'react';
import s from './ColumnsInfoItem.scss';
import classNames from 'classnames';
import {InfoSectionDescription} from '../../../InfoSectionDescription/InfoSectionDescription';
import {InfoSectionTitle} from '../../../InfoSectionTitle/InfoSectionTitle';
import {InfoSectionLayoutId} from '../../../../../constants';
import {withGlobalProps, type ProvidedGlobalProps} from '../../../../../providers/globalPropsProvider';
import {SPECS} from '../../../../../specs';
import stylesParams from '../../../../../../components/ProductPage/stylesParams';

export enum ColumnsInfoItemDataHook {
  Root = 'columns-info-item',
}

export interface InfoSectionColumnsProps extends ProvidedGlobalProps {
  description: string;
  index: number;
  title: string;
  numberOfColumns: number;
}

class ColumnsInfoItemBase extends React.Component<InfoSectionColumnsProps> {
  public render(): JSX.Element {
    const {description, title, numberOfColumns, index, globals} = this.props;
    const isShowDividers = globals.styles.get(stylesParams.productPage_infoSectionShowDeviders);
    const isResponsive = globals.isResponsive;

    const infoSectionColumnsClass = classNames(
      s.container,
      {[s.whenOneColumns]: numberOfColumns === 1 && !isResponsive},
      {[s.whenTwoColumns]: numberOfColumns === 2 && !isResponsive},
      {[s.whenThreeColumns]: numberOfColumns === 3 && !isResponsive},
      {[s.withDivider]: numberOfColumns > 1 || (isResponsive && isShowDividers)},
      {[s.responsiveLayout]: isResponsive},
      {[s.legacyLists]: !globals.useExperiments.enabled(SPECS.InfoSectionRicosGalleryListFix)}
    );

    return (
      <li className={infoSectionColumnsClass} data-hook={ColumnsInfoItemDataHook.Root}>
        <InfoSectionTitle theme={InfoSectionLayoutId.Columns} title={title} />
        <InfoSectionDescription description={description} index={index} />
      </li>
    );
  }
}

export const ColumnsInfoItem = withGlobalProps(ColumnsInfoItemBase);
